'use client';

import { createContext, Dispatch, SetStateAction, useContext, useEffect, useState } from 'react';
import { LOCALES } from '../';

// set up a context that makes a getter and setter commonly available to
// components:
export const LocaleAvailabilityContext = createContext<{
  locales: string[];
  setLocales: Dispatch<SetStateAction<string[]>>;
}>({
  // these values should be set by the Provider props:
  locales: [],
  setLocales: (_) => {
    throw new Error('setLocales was not initialised in the LocaleAvailabilityContext');
  },
});

// children of the LocaleAvailabilityContextProvider component
// can access the getter and setter from the context:
export function LocaleAvailabilityContextProvider({ children }) {
  const [items, setItems] = useState(Object.keys(LOCALES));

  // the context provider is initialised with the getter and setter
  // for the available locales. The provider can then be
  // retrieved by children of the context provider component:
  return (
    <LocaleAvailabilityContext.Provider value={{ locales: items, setLocales: setItems }}>
      {children}
    </LocaleAvailabilityContext.Provider>
  );
}

// the context can only be accessed from client-side components
// this component can be initialised server-side and set the locale
// when served client side:
export function LocaleAvailabilitySetter({ availableLocales }) {
  // set the available locales once, when the component mounts:
  const { setLocales: setAvailableLocales } = useContext(LocaleAvailabilityContext);
  useEffect(() => {
    setAvailableLocales(availableLocales);
  }, [availableLocales, setAvailableLocales]);
  return null;
}
